module.exports = __webpack_public_path__ + "img/companies.981bbf6b.svg";